// extracted by mini-css-extract-plugin
module.exports = {"register-wrapper":"Register_register-wrapper__hDjFK","register":"Register_register__iVO6y"};